import { AttributeCode } from 'services/model/model.service';

export type CoreEntity = 'product' | 'style' | 'category' | 'article';

export type ToggleButtons = 'marketplace' | 'country' | 'style' | 'size' | 'article' | 'product' | 'brand';

export interface AttributeDisplayDescriptor {
  key?: string;
  label?: string;
  attributeCode: AttributeCode;
  attributeValue?: string;
  useRaw?: boolean;
  link?: string;
}

export interface ListAttributeDisplayDescriptor {
  key?: string;
  attributeCode: AttributeCode;
  labelId?: string;
  attributeValues: string[];
  useRaw?: boolean;
}

export const attributeToToggleTranslationKey = {
  chnMarketplace: 'marketplace',
  chnCountry: 'country',
  styBrandColor: 'style',
  artEan: 'article',
  artSize: 'size',
  prdNumber: 'product',
  prdBrand: 'brand',
} as Record<AttributeCode, ToggleButtons>;

const toggleTrackingNames: Record<ToggleButtons, string> = {
  marketplace: 'Marketplace',
  country: 'Country',
  style: 'Style',
  size: 'Size',
  article: 'Article',
  product: 'Product',
  brand: 'Brand',
};

export function getAttributeToggleTrackingName(attributeCode: AttributeCode): string {
  const toggleKey = attributeToToggleTranslationKey[attributeCode];
  return toggleKey ? toggleTrackingNames[toggleKey] : attributeCode;
}

export const attributeToTableHeaderTranslationKey = {
  prdCategory: 'category',
  chnCountry: 'country',
  styBrandColor: 'style',
  artEan: 'article.ean',
  artSize: 'size',
  artImageUrl: 'image',
} as Record<AttributeCode, string>;
